/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2018, Zumper
 * @description default filters
 */

import { isZumper } from '@zcode/env'
import { FilterRecordType } from '../bizos/filter'

const getZumperDefaultFilters = () => {
  return new FilterRecordType({ longTerm: true, shortTerm: false, maxPrice: 10000 })
}

const getZumperDefaultSTFilters = () => {
  return new FilterRecordType({ longTerm: false, shortTerm: true })
}

const getPadMapperDefaultFilters = () => {
  return new FilterRecordType()
}

/** @type {import('@zcode/state-type').Filters} */
const DEFAULT_FILTERS = isZumper ? getZumperDefaultFilters() : getPadMapperDefaultFilters()

export const DEFAULT_ST_FILTERS = getZumperDefaultSTFilters()

export default DEFAULT_FILTERS
